export const inventoryPolicy = {
  CONTINUE: 'continue',
  DENY: 'deny'
};

export const inventoryManagement = {
  TRACKING: 'shopify'
};

export const StoreFrontAPIConfig = {
  // Used by storefront-client.js to build the graphql endpoint
  VERSION: '2025-01'
};

export const productTypes = {
  YARN: 'yarn',
  HOOKS: 'crochet_hooks',
  NEEDLES: 'knitting_needles',
  ACCESSORY: 'accessory',
  BOOK: 'book',
  CROCHET: 'crochet',
  KNITTING: 'knitting'
};

export const currencyFormats = {
  AMOUNT: 'amount',
  AMOUNT_NO_DECIMALS: 'amount_no_decimals',
  AMOUNT_WITH_COMMA_SEPARATOR: 'amount_with_comma_separator',
  AMOUNT_NO_DECIMALS_WITH_COMMA_SEPARATOR:
    'amount_no_decimals_with_comma_separator',
  AMOUNT_WITH_APOSTROPHE_SEPARATOR: 'amount_with_apostrophe_separator'
};

/**
 * Gift card amounts in cents for pattern download modal, mapped by locale
 * Amounts are in cents (e.g., 5000 = 50.00, 50000 = 500.00)
 */
export const patternDownloadGiftCardAmounts = {
  da: 50000, // Denmark: kr. 500
  de: 5000, // Germany: € 50
  en: 5000, // US/UK: $50 / £50
  es: 5000, // Spain: € 50
  fi: 5000, // Finland: € 50
  fr: 5000, // France: € 50
  it: 5000, // Italy: € 50
  nb: 50000, // Norway: kr 500
  nl: 5000, // Netherlands: € 50
  no: 50000, // Norway: kr 500
  pl: 25000, // Poland: zł 250
  sv: 50000 // Sweden: kr 500
};
